module.exports = __webpack_public_path__ + "img/app.44839a12.jpg";